import { storageFactory as o } from "./storageFactory.js";
const r = o(localStorage), s = o(sessionStorage);
export {
  r as localStore,
  s as sessionStore
};
//# sourceMappingURL=index.js.map
